<template>
  <el-dialog
    title="选择客户"
    :visible.sync="visible"
    width="520px"
    @close="$emit('update:show', false)"
    @open="opened"
    :append-to-body="inner"
    :close-on-click-modal="false"
  >
    <el-input
      v-model="query"
      placeholder="输入客户名称后回车搜索"
      @change="queryChange"
      @input="inputChange"
      clearable
    ></el-input>
    <p
      class="text-info-12 mt-20"
      v-if="!searched && activeCustomers.length > 0"
    >
      最近操作客户：
    </p>
    <el-table
      v-loading="loading"
      v-if="list.length > 0"
      ref="multipleTable"
      :data="list"
      :show-header="false"
      style="width: 100%"
      size="small"
    >
      <el-table-column prop="name" label="客户名称">
        <template slot-scope="scope">
          {{ scope.row.name }}
          <span v-if="auth.isPlatformUser() && scope.row.sap_code"
            >（{{ scope.row.sap_code }}）</span
          >
        </template>
      </el-table-column>
      <el-table-column width="78">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            plain
            @click="select(scope.$index)"
            >选择</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <p
      class="text-info-12 mt-20"
      v-if="query.length > 0 && customers.length == 0 && searched"
    >
      未找到相关客户
    </p>
  </el-dialog>
</template>

<script>
import { customerList } from '../service/getData'
import auth from '@/util/auth'
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    inner: {
      type: Boolean,
      default: false,
    },
    selection: {
      type: Array,
      default: () => [],
    },
    activeCustomers: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
  },
  computed: {
    list() {
      if (this.query.length > 0 && this.searched) {
        return this.customers
      } else {
        return this.activeCustomers
      }
    },
  },
  data() {
    return {
      query: '',
      searched: false,
      visible: this.show,
      customers: [],
      loading: false,
      auth,
    }
  },
  created() {},
  methods: {
    async requestCustomers() {
      this.loading = true
      this.searched = false
      let data = {
        name: this.query,
        size: 10,
        page: 0,
        special_mark: -1,
      }
      let res = await customerList(data)
      if (res.code == 0) {
        this.customers = res.data.list
      }
      this.searched = true
      this.loading = false
    },
    select(index) {
      this.visible = false
      this.$emit('selected', this.list[index])
    },
    opened() {},
    inputChange() {
      this.customers = []
      this.searched = false
    },
    queryChange() {
      if (this.query.length == 0) {
        this.customers = []
        this.searched = false
      } else {
        this.requestCustomers()
      }
    },
  },
}
</script>